<template>
  <div class="result-type-wrapper">
    <Icon class="result-icon succ" v-if="state == 'success'"></Icon>
    <Icon class="result-icon storing" v-if="state == 'storing'"></Icon>
    <Icon class="result-icon fail" v-if="state == 'fail'"></Icon>
    <p class="result-title">{{ title }}</p>
    <p class="opera-tips" v-html="tips"></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['title', 'tips', 'state']
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.result-type-wrapper {
  display: inline-block;
  margin-top: 45px;
  width: 100%;
}
.result-icon {
  margin: 0 auto;
  width: 70px;
  height: 70px;
  &.succ {
    background: url($tmslgImg + 'result-succ-ico.png') no-repeat;
  }
  &.fail {
    background: url($tmslgImg + 'result-fail-ico.png') no-repeat;
  }
  &.storing {
    background: url($tmslgImg + 'result-storing-ico.png') no-repeat;
    width: 71px;
    height: 71px;
  }
}
.result-title {
  margin-top: 45px;
  margin-bottom: 17px;
  width: 100%;
  text-align: center;
  font-size: 28px;
  color: #333;
  font-weight: bold;
}
.opera-tips {
  margin: 0 auto;
  line-height: 30px;
  text-align: center;
  font-size: 22px;
  color: #666;
}
</style>
